import { ActionContext } from "vuex";

export default {
  namespaced: true,
  state: {
    filter: {
      eid: undefined,
    },
    items: [] as any[],
    updated_index: -1,
    esim_detail: undefined,
    // この環境の eIM サーバーの版。画面の下部に出す（CC_NTTC-1451 A-5）
    version: null as string | null,
  },
  getters: {
    getItems: (state: any) => state.items || [],
    getUpdatedIndex: (state: any) => state.updated_index,
  },
  mutations: {
    APPLY_FILTER: (state: any, payload: any) => (state.filter = payload),
    SET_ITEMS: (state: any, payload: any) => (state.items = payload),
    SET_ESIM_DETAIL: (state: any, payload: any) => (state.esim_detail = payload),
    SET_UPDATED_INDEX: (state: any, payload: any) => (state.updated_index = payload),
    SET_VERSION: (state: any, payload: string | null) => (state.version = payload),
  },
  actions: {
    applyFilter: ({ commit }: ActionContext<any, any>, payload: any) => commit("APPLY_FILTER", payload),

    setESimDetail: ({ commit }: ActionContext<any, any>, payload: any) => commit("SET_ESIM_DETAIL", payload),
    setVersion: ({ commit }: ActionContext<any, any>, payload: string | null) => commit("SET_VERSION", payload),
    refreshItems: ({ state, commit }: ActionContext<any, any>) => {
      commit("SET_ITEMS", [...state.items]);
    },
    cleaUpdatedIndex: ({ commit }: ActionContext<any, any>) => {
      commit("SET_UPDATED_INDEX", -1);
    },
  },
};
